/**
 * Staff category CRUD endpoints.
 */
import { apiRequest, normalizeList } from "./staffUtils";
import { toDisplayString } from "../../utils/toDisplayString";

export const staffCategoryInitialState = {
  staffCategories: [],
  staffCategoriesLoading: false,
  staffCategoriesError: null,
  staffCategoryDetail: null,
  staffCategoryDetailLoading: false,
  staffCategoryDetailError: null,
  staffCategoryMutationLoading: false,
  staffCategoryMutationError: null,
};

export function createStaffCategoryActions(set, get) {
  async function mutate(path, method, body, message) {
    set({ staffCategoryMutationLoading: true, staffCategoryMutationError: null });
    try {
      const data = await apiRequest(get, path, { method, body });
      set({
        staffCategoryMutationLoading: false,
        staffCategoryMutationError: null,
        successMessage: message,
      });
      return { success: true, data: data?.data ?? data };
    } catch (err) {
      const error = toDisplayString(err.message, "Category action failed");
      set({ staffCategoryMutationLoading: false, staffCategoryMutationError: error });
      return { success: false, error };
    }
  }

  return {
    fetchStaffCategories: async () => {
      set({ staffCategoriesLoading: true, staffCategoriesError: null });
      try {
        const data = await apiRequest(get, "/api/staff/categories");
        const { items } = normalizeList(data, ["categories"]);
        set({ staffCategoriesLoading: false, staffCategories: items });
        return { success: true, items };
      } catch (err) {
        const error = toDisplayString(err.message, "Failed to load categories");
        set({ staffCategoriesLoading: false, staffCategoriesError: error });
        return { success: false, error };
      }
    },
    fetchStaffCategory: async (id) => {
      set({ staffCategoryDetailLoading: true, staffCategoryDetailError: null });
      try {
        const data = await apiRequest(get, `/api/staff/categories/${id}`);
        const category = data?.data ?? data?.category ?? data;
        set({ staffCategoryDetailLoading: false, staffCategoryDetail: category });
        return { success: true, data: category };
      } catch (err) {
        const error = toDisplayString(err.message, "Failed to load category");
        set({ staffCategoryDetailLoading: false, staffCategoryDetailError: error });
        return { success: false, error };
      }
    },
    createStaffCategory: (payload) =>
      mutate("/api/staff/categories", "POST", payload, "Category created successfully"),
    updateStaffCategory: (id, payload) =>
      mutate(`/api/staff/categories/${id}`, "PATCH", payload, "Category updated successfully"),
    deleteStaffCategory: (id) =>
      mutate(`/api/staff/categories/${id}`, "DELETE", undefined, "Category deleted successfully"),
  };
}
